module.exports = "../../static/images/course-show3.ce566f.png";